import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';

var getWindowDimensions = function getWindowDimensions() {
  var _window;

  /* istanbul ignore next */
  var _ref =
  /* istanbul ignore next */
  (_window = window
  /* istanbul ignore next */
  ) !== null && _window !== void 0 ? _window : {},
      width = _ref.innerWidth,
      height = _ref.innerHeight;
  /* istanbul ignore next */


  return {
    width: width,
    height: height
  };
};

export var useWindowDimensions = function useWindowDimensions() {
  var _useState = useState(getWindowDimensions()),
      _useState2 = _slicedToArray(_useState, 2),
      windowDimensions = _useState2[0],
      setWindowDimensions = _useState2[1];

  var timer = useRef();
  var clearTimer = useCallback(function () {
    if (timer.current) clearTimeout(timer.current);
  }, []);
  var handleResize = useCallback(function () {
    if (timer.current) clearTimer();
    timer.current = setTimeout(function () {
      return setWindowDimensions(getWindowDimensions());
    }, 25);
  }, []);
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      clearTimer();
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowDimensions;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/useWindowDimensions.js
// module id = 1635
// module chunks = 11